import { store } from '.'

export const useStore = () => {
  return store
}
